import { isInBrowser } from './isInBrowser.js';

var _a;
const _global = getGlobal();
function getGlobal() {
    if (isInBrowser())
        return window;
}
function getGlobalSupport() {
    if (isInBrowser()) {
        _global.__biliMirror__ = _global.__biliMirror__ || {};
        return _global.__biliMirror__;
    }
}
const spmId = isInBrowser() ? ((_a = document.getElementsByTagName('meta')['spm_prefix']) === null || _a === void 0 ? void 0 : _a.content) || '0.0' : '0.0';
const defalutSpmId = spmId;
/**
 * 添加事件监听器
 */
function on(target, eventName, handler, opitons = false) {
    target.addEventListener(eventName, handler, opitons);
}
// 获取当前的时间戳
function getTimestamp() {
    return Date.now();
}
const nativeToString = Object.prototype.toString;
function isType(type) {
    return function (value) {
        return nativeToString.call(value) === `[object ${type}]`;
    };
}
/**
 * 检测变量类型
 * @param type
 */
const variableTypeDetection = {
    isNumber: isType('Number'),
    isString: isType('String'),
    isBoolean: isType('Boolean'),
    isNull: isType('Null'),
    isUndefined: isType('Undefined'),
    isSymbol: isType('Symbol'),
    isFunction: isType('Function'),
    isObject: isType('Object'),
    isArray: isType('Array'),
    isProcess: isType('process'),
    isWindow: isType('Window')
};
function resourceTransform(target) {
    return {
        time: getTimestamp(),
        message: target.src || target.href || '',
        name: target.localName
    };
}
function unknownToString(target) {
    if (variableTypeDetection.isString(target)) {
        return target;
    }
    if (variableTypeDetection.isUndefined(target)) {
        return 'undefined';
    }
    return JSON.stringify(target);
}
// 生成唯一错误id
function getErrorId(val) {
    return window.btoa(decodeURIComponent(encodeURIComponent(val)));
}
// mirror 字符串规范
function mirrorStringRep(str) {
    const key = /^[0-9a-zA-Z_-]+$/;
    const res = key.test(str);
    if (!res) {
        console.warn(`字符串:${str},不符合条件,任意数字,字母、下划线、中划线组成`);
    }
    return res;
}
/**
 * 通过正则过滤上报信息
 * @param error
 * @param regExps
 * @param filterJs 是否过滤非.js文件
 * @returns
 */
const handlerFilter = (error, regExps = ['chrome-extension'], filterJs = false) => {
    if (regExps.length === 0)
        return false;
    if ((error === null || error === void 0 ? void 0 : error.message) == null)
        return true;
    // 忽略参数
    const [message] = error.message.split('?');
    // 报错信息和当前url的domain 存在 不上报,-img 空src需求
    if (message.includes(location.hostname))
        return true;
    const fileName = (error === null || error === void 0 ? void 0 : error.fileName) || '';
    // 过滤fileName 不是.js文件结尾 无法被source-map解析,上报后大多数无法解决,意义不大(kv-配置)
    if (filterJs && !fileName.endsWith('.js'))
        return true;
    try {
        return regExps
            .map(str => new RegExp(String.raw `${str}`))
            .some(regExp => regExp.test(message) || regExp.test(fileName));
    }
    catch (error) {
        console.error('Invalid regular expression:', error);
        return false;
    }
};
/**
 * 通过正则过滤ua相关信息
 * @param uaExps
 * @returns
 */
const handlerFilterUa = (uaExps = []) => {
    if (uaExps.length === 0)
        return false;
    try {
        return uaExps.some(uaExp => new RegExp(String.raw `${uaExp}`).test(navigator.userAgent));
    }
    catch (error) {
        return false;
    }
};
// 采样值设置范围
function checkRate(str) {
    // string "0" 全部关闭采样
    if (str === '0') {
        return 0;
    }
    if (variableTypeDetection.isNumber(str)) {
        return str > 10 ? 10 : str <= 0 ? 1 : str;
    }
    else if (variableTypeDetection.isString(str) && !isNaN(str)) {
        const num = parseInt(str);
        return num > 10 ? 10 : num <= 0 ? 1 : num;
    }
    else {
        console.warn('mirror-kv-[config] sampling rate error,please set 1-10');
        return 1;
    }
}
// 采样,获取1-10随机数， val-1即代表10%采样率
function getSampling(val) {
    const samplingValue = Math.floor(Math.random() * 10 + 1);
    return samplingValue > val;
}
function getLocationHref() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    return document.location.href;
}
/**
 * 将地址字符串转换成对象，
 * 输入：'https://www.bilibili.com/mirror/urlpath?token=123&name=11'
 * 输出：{
 *  "host": "www.bilibili,com",
 *  "path": "/mirror/urlpath",
 *  "protocol": "https",
 *  "relative": "/mirror/urlpath?token=123&name=11"
 * }
 */
function parseUrlToObj(url) {
    if (!url) {
        return {};
    }
    const match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
/**
 *
 * 重写对象上面的某个属性
 * ../param source 需要被重写的对象
 * ../param name 需要被重写对象的key
 * ../param replacement 以原有的函数作为参数，执行并重写原有函数
 * ../param isForced 是否强制重写（可能原先没有该属性）
 * ../returns void
 */
function replaceAop(source, name, replacement, isForced = false) {
    if (source === undefined)
        return;
    if (name in source || isForced) {
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            source[name] = wrapped;
        }
    }
}
// 是否有对应的key
function isExistProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/**
 * 函数节流
 * fn 需要节流的函数
 * delay 节流的时间间隔
 * 返回一个包含节流功能的函数
 */
const throttle = (fn, delay) => {
    let canRun = true;
    return function (...args) {
        if (!canRun)
            return;
        fn.apply(this, args);
        canRun = false;
        setTimeout(() => {
            canRun = true;
        }, delay);
    };
};
/**
 * Creates a debounced version of the provided function.
 *
 * @param func - The function to debounce.
 * @param delay - The delay in milliseconds.
 * @returns A debounced version of the function.
 */
const debounce = (func, delay) => {
    let timerId;
    return function (...args) {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};
/**
 * @param target html节点
 */
function htmlElementAsString(e) {
    const tagName = e.target.tagName.toLowerCase();
    // 如果是 html 或 body 标签，返回空字符串
    if (tagName === 'html' || tagName === 'body') {
        return '';
    }
    let outerHTML = e.target.outerHTML;
    // 如果是 path 标签，移除 d 属性
    if (tagName === 'path') {
        outerHTML = outerHTML.replace(/ d="[^"]*"/, '');
    }
    const match = outerHTML.match(/<[^>]*>/); // 匹配 HTML 标签的开头部分
    const textContent = e.target.childNodes.length > 0 && e.target.childNodes[0].nodeType === 3 ? e.target.childNodes[0].nodeValue : ''; // 获取元素的文本内容
    return match ? match[0] + textContent + '</' + tagName + '>' : '';
}
function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function deepMerge(target, source) {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = deepMerge(target[key], source[key]);
            }
            else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
}
function getCurrentDateTime() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).length === 1 ? '0' + (date.getMonth() + 1) : String(date.getMonth() + 1);
    const day = String(date.getDate()).length === 1 ? '0' + date.getDate() : String(date.getDate());
    const hours = String(date.getHours()).length === 1 ? '0' + date.getHours() : String(date.getHours());
    const minutes = String(date.getMinutes()).length === 1 ? '0' + date.getMinutes() : String(date.getMinutes());
    const seconds = String(date.getSeconds()).length === 1 ? '0' + date.getSeconds() : String(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export { _global, checkRate, debounce, deepMerge, defalutSpmId, getCurrentDateTime, getErrorId, getGlobal, getGlobalSupport, getLocationHref, getSampling, getTimestamp, handlerFilter, handlerFilterUa, htmlElementAsString, isExistProperty, mirrorStringRep, nativeToString, on, parseUrlToObj, replaceAop, resourceTransform, throttle, unknownToString, variableTypeDetection };
